export default {
  // Navigation
  nav: {
    home: 'Home',
    menu: 'Menu',
    about: 'About',
    reservation: 'Reservation',
    contact: 'Contact',
    gallery: 'Gallery',
    menuOpen: 'Open menu',
    menuClose: 'Close menu',
    reserveTable: 'Reserve a Table'
  },

  // Header
  header: {
    call: 'Call',
    openNow: 'Open now',
    closed: 'Closed'
  },

  // Hero
  hero: {
    title: 'Authentic Italian Cuisine',
    subtitle: 'Welcome to Bella Vista',
    description: 'Experience the flavors of Italy in Munich. Fresh ingredients, traditional recipes, and warm hospitality since 1985.',
    cta: 'Reserve a Table',
    ctaSecondary: 'View Menu'
  },

  // USP Bar
  usp: {
    fresh: 'Fresh Ingredients',
    freshDesc: 'Daily from the market',
    homemade: 'Homemade',
    homemadeDesc: 'Traditional recipes',
    since: 'Since 1985',
    sinceDesc: 'Family tradition'
  },

  // Featured Dishes
  featured: {
    title: 'Our Recommendations',
    subtitle: 'Discover our most popular creations',
    viewAll: 'View all dishes'
  },

  // About Teaser
  aboutTeaser: {
    title: 'Our Story',
    subtitle: 'A journey through generations',
    description: 'Founded in 1985 by the Rossi family, Bella Vista brings the authentic flair of Italian cuisine to Munich. Our passion for premium ingredients and traditional recipes makes every visit a special experience.',
    chef: 'Head Chef',
    learnMore: 'Learn more'
  },

  // Testimonials
  testimonials: {
    title: 'What Our Guests Say',
    subtitle: 'Reviews from Google & TripAdvisor'
  },

  // Location & Hours
  location: {
    title: 'Visit Us',
    subtitle: 'We look forward to welcoming you',
    address: 'Address',
    hours: 'Opening Hours',
    getDirections: 'Get Directions',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    closedDay: 'Closed'
  },

  // Reservation CTA
  reservationCta: {
    title: 'Reserve Your Table',
    description: 'Secure your spot for an unforgettable culinary experience.',
    cta: 'Reserve now',
    or: 'or call us'
  },

  // Menu Page
  menuPage: {
    title: 'Our Menu',
    subtitle: 'Authentic Italian dishes',
    filter: 'Filter',
    all: 'All',
    filterDietary: 'Dietary filters',
    vegetarian: 'Vegetarian',
    vegan: 'Vegan',
    glutenFree: 'Gluten-free',
    categories: {
      antipasti: 'Antipasti',
      pasta: 'Pasta',
      pizza: 'Pizza',
      secondi: 'Main Courses',
      dolci: 'Desserts',
      beverages: 'Beverages'
    }
  },

  // About Page
  aboutPage: {
    title: 'About Bella Vista',
    subtitle: 'Tradition meets passion',
    historyTitle: 'Our History',
    historyText1: 'In 1985, the Rossi family opened a small restaurant in Munich with the dream of bringing authentic Italian cuisine to Bavaria. What began as a small family business has become a beloved destination for lovers of Italian food.',
    historyText2: 'Three generations later, we continue this tradition with the same passion and dedication. Every dish tells a story – from our grandmother\'s recipes to the modern creations of our head chef.',
    valuesTitle: 'Our Values',
    values: {
      quality: 'Quality',
      qualityDesc: 'Only the finest ingredients make it into our kitchen.',
      tradition: 'Tradition',
      traditionDesc: 'Authentic recipes passed down through generations.',
      hospitality: 'Hospitality',
      hospitalityDesc: 'Every guest is part of our family.'
    },
    teamTitle: 'Our Team',
    teamSubtitle: 'The people behind the experience'
  },

  // Reservation Page
  reservationPage: {
    title: 'Reserve a Table',
    subtitle: 'We look forward to your visit',
    form: {
      date: 'Date',
      time: 'Time',
      guests: 'Number of Guests',
      guestsPlaceholder: 'Number of people',
      name: 'Name',
      namePlaceholder: 'Your full name',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      phone: 'Phone',
      phonePlaceholder: '+49 123 456789',
      notes: 'Special Requests',
      notesPlaceholder: 'Allergies, special occasions, etc.',
      submit: 'Request Reservation',
      person: 'Person',
      persons: 'Persons'
    },
    demoNotice: 'This is a demo website. Reservations are not processed.',
    success: 'Thank you! Your reservation request has been sent.',
    info: {
      title: 'Good to Know',
      items: [
        'Reservations are confirmed within 2 hours',
        'For groups of 8 or more, please contact us by phone',
        'Cancellations please up to 24h before the appointment'
      ]
    }
  },

  // Contact Page
  contactPage: {
    title: 'Contact',
    subtitle: 'We\'re here for you',
    form: {
      name: 'Name',
      namePlaceholder: 'Your name',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      subject: 'Subject',
      subjectPlaceholder: 'What is this about?',
      message: 'Message',
      messagePlaceholder: 'Your message to us...',
      submit: 'Send Message'
    },
    info: {
      address: 'Address',
      addressValue: 'Maximilianstraße 45, 80539 Munich',
      phone: 'Phone',
      phoneValue: '089 - 987 654 32',
      email: 'Email',
      emailValue: 'info@bella-vista-muenchen.de',
      hours: 'Opening Hours'
    },
    demoNotice: 'This is a demo website. Messages are not processed.'
  },

  // Gallery Page
  gallery: {
    title: 'Gallery',
    subtitle: 'A glimpse into our restaurant',
    filters: {
      all: 'All',
      food: 'Dishes',
      interior: 'Interior',
      events: 'Events',
      team: 'Team'
    },
    lightbox: {
      close: 'Close',
      prev: 'Previous image',
      next: 'Next image'
    }
  },

  // Footer
  footer: {
    description: 'Authentic Italian cuisine in Munich. Fresh ingredients, homemade pasta, and warm hospitality since 1985.',
    quickLinks: 'Quick Links',
    contact: 'Contact',
    hours: 'Opening Hours',
    newsletter: 'Newsletter',
    newsletterDesc: 'Receive news and exclusive offers.',
    emailPlaceholder: 'Your email',
    subscribe: 'Subscribe',
    copyright: '© {year} Bella Vista. All rights reserved.',
    privacy: 'Privacy Policy',
    imprint: 'Imprint'
  },

  // Demo Banner
  demo: {
    title: 'Demo Project',
    description: 'This is a portfolio demo project',
    descriptionShort: 'Portfolio demo',
    close: 'Close',
    footerText: 'Demo project by'
  },

  // Cookies
  cookies: {
    title: 'Cookie Notice',
    message: 'We use cookies to improve your experience. By using our site, you agree to our privacy policy.',
    accept: 'Accept',
    decline: 'Decline'
  },

  // Common
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    readMore: 'Read more',
    backToTop: 'Back to top',
    price: 'Price',
    from: 'from'
  },

  // Privacy Page
  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last updated: January 2025'
  },

  // Imprint Page
  imprint: {
    title: 'Imprint',
    operator: 'Operator',
    contact: 'Contact',
    legal: 'Legal Notice',
    demoNotice: 'This is a demo website for portfolio purposes. Bella Vista is a fictional restaurant.'
  }
};
